//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './css/about.css';

export default class About extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			statua: false,
		};
  };

  
  
  async componentDidMount() {
		document.title = "About | Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
		this.setState({statua: true});
	}

	componentWillUnmount() {
	}


	

	render() {
		
		return (
			<>
				{this.state.statua &&
					<>

						<div className="contact">
							<div className="contact-background"></div>
						</div>

						<div className="article">
							<Row className="gx-0">
								<Col className="contact-header">
									<h1>About Mix365</h1>
								</Col>
							</Row>
						</div>
						
						<div className="about-aboutus">
							<div className="article">
								<Row className="article-entry">
									<Col md={6} className="">
										<img src="/images/home-bg01.jpg" alt="About Mix365" />
									</Col>
									<Col className="text-vertical">
										<div>
										<h3 className="about-title">Welcome to mix365</h3>
											Mix365 is your station that comes alive with audio streaming 24/7, LIVE DJ performances and LIVE video streaming to all of the major video on demand platforms. We pride ourselves in everything we do. Take a look around the website.. see what we are all about, see the DJ schedule and find out when your favorite DJ is playing next. We aim to provide you with a great service, this is a place to enjoy yourself.. a place where you can keep coming back time after time..<br /><br />
											Follow us on our Social Media Platforms<br />
											<div className="pt-2">
												<a href="https://www.facebook.com/groups/mix365" title="Facebook" target="_blank" rel="noreferrer" className="pr-3">
													<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" />
												</a>
												<a href="https://www.instagram.com/mix365radio/" title="Instagram" target="_blank" rel="noreferrer" className="pr-3">
													<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" />
												</a>
												<a href="https://twitter.com/Mix365R" title="Twitter" target="_blank" rel="noreferrer" className="pr-3">
													<FontAwesomeIcon icon={['fab', 'twitter']} className="header-socials" />
												</a>
												<a href="https://discord.gg/bvs8QNeDhq" title="Discord" target="_blank" rel="noreferrer" className="pr-3">
													<FontAwesomeIcon icon={['fab', 'discord']} className="header-socials" />
												</a>
											</div>
										</div>
									</Col>
								</Row>
							</div>
						</div>

						<div className="about-spliiter">
							<div className="about-spliiter-text">
								<Row>
									<Col sm={3} className="text-center">
										<h1 className="about-title">24/7</h1>
										<h3>AUDIO</h3>
									</Col>
									<Col sm={3} className="text-center">
										<h1 className="about-title">LIVE</h1>
										<h3>DJ'S</h3>
									</Col>
									<Col sm={3} className="text-center">
										<h1 className="about-title">LIVE</h1>
										<h3>VIDEO STREAMS</h3>
									</Col>
									<Col sm={3} className="text-center">
										<h1 className="about-title">LIVE</h1>
										<h3>INTERACTION</h3>
									</Col>
								</Row>
							</div>
						</div>


						<div className="article py-5">
							<Row className="py-5">
								<Col className="my-5 py-5">
									<h3 className="about-title">Something about us</h3>
									In 2017 Mix365 was born and started streaming to a single (already established) audio only platform. We started to gain interest from our followers, so decided to open our very own website. Starting with a simple website, a chat room and audio only we have grown at a fast rate. We now operate our very own cloud system which is centralized and allows us to simultaneously stream to multiple platforms.<br /><br />
									We love what we do and will continue to grow bigger and better. We have a passion to provide our listeners and viewers, with the best possible live streaming experience.  We know we cant cater for everyone's taste in music, but if we know you are happy and enjoying what we do then so are we. We want you to remember your experience with us.. 
								</Col>
								{/*<Col>
									Image
								</Col>*/}
							</Row>
						</div>

						<div className="about-spliiter">
							<div className="about-spliiter-text">
								<Row>
									<Col md={6}>
										<h1>we will make your day..</h1>
										<h3 className="about-title">A MEMORY.</h3>
									</Col>
									<Col md={4}>
										<img src="/images/240_F_238480884_FIgHLW3DMENF5hhGaXYMZ7WdmwmIwpS1.jpg" width="100%" />
									</Col>
								</Row>
							</div>
						</div>


						<div className="article">
							<Row>
								
							</Row>
							<Row>
								<Col className="text-center py-5">
									<h3 className="about-title pb-2">Where we play</h3>
									As well as streaming live to you here - our home of Mix365, we stream to other major platforms too. These include the below..
								</Col>
							</Row>
							<Row className="text-center">
								<Col md={{span: 4, offset: 2}} className="pb-5">

									<a className="aboutus-platform" href="https://www.mixcloud.com/live/mix365" target="_blank" rel="noreferrer">
										<img classname="" src="/images/mixcloud-logo.png" title="Mixcloud logo" alt="Mixcloud logo" />
									</a><br />

									<h3 className="about-title pb-2">MIXCLOUD</h3><br />
									Explore thousands of radio shows, DJ Mixes, Playlists and Podcast for free. Please click on the above image to be taken to our page to see a DJ Live when they are playing.
								</Col>
								<Col md={4} className="pb-5">
									
									<a className="aboutus-platform" href="https://www.twitch.tv/365radio" target="_blank" rel="noreferrer">
										<img classname="" src="/images/twitch-logo.png" title="twitch logo" alt="twitch logo" />
									</a><br />

									<h3 className="about-title pb-2">TWITCH</h3>
									Twitch is an interactive livestreaming service for content spanning gaming, sports, entertainment and of course music. Please click on the above image to be taken to our page to see a DJ Live when they are playing.
								</Col>
								<Col md={{span: 4, offset: 2}} className="pb-5">
									
									<a className="aboutus-platform" href="https://hearthis.at/mix365-radio/" target="_blank" rel="noreferrer">
										<img classname="" src="/images/white.png" title="white" alt="white" />
									</a><br />
									
									<h3 className="about-title pb-2">HEARTHIS.AT</h3>
									Live streaming on hearthis.at is the best way to broadcast podcasts, radio shows or live sessions. Please click on the above image to be taken to our page to see a DJ Live when they are playing.
								</Col>
								<Col md={4} className="pb-5">
									
									<div className="aboutus-platform">
									<img classname="" src="/images/event-img04.png" title="event-img04" alt="event-img04" />
									</div><br />
									
									<h3 className="about-title pb-2">PRIVATE FUNCTIONS / PARTY</h3>
									Our systems allows us to come straight to you, either virtually or we can attend your event / party. For more info please contact us.
								</Col>
							</Row>
							{/*<Row>
								<Col>PPL License???</Col>
							</Row>*/}
						</div>
					</>
				}
			</>
		);
	}
}
